/*
  Interface de saisie des mouvements de stock.

  Le formulaire comporte les champs de saisie suivants :
    - marque
    - ref constructeur
    - libellé
    - quantité
  La recherche
    Un bouton proposant de scanner le code barre est affiché :
      il bascule vers le module de scancode.
      Si la lecture se fait, le code lu permet de rechercher l'article dans la base de données (lecture code barre dans le référentiel).
      Le scénario suivant est le même que celui de la recherche manuelle.
    Un champ de recherche par référence est proposé en entrée.
    Ce champ permet de sélectionner une référnce dans la liste des références connues (leture des références dans le référentiel)

  Si la référence existe :
    le formulaire est alimenté : marque / ref / libellé
    le champ de saisie de la quanité est ouvert

  Si la référence n'existe pas :
    elle est créée : sasie des champs marque / ref / libellé
  Dans les deux cas la quantité physique est saisie

  A la validation :
    recherche de la référence dans le stock :
      Si la référence est nouvelle dans le stock, elle est créée. La valeur virtuelle en stock est positionnée au stock physique.
      Si la référence existe dans le stock : la valeur en stock est récupérée.
      En final :
        si il n'y a aucune différence entre le stock virtuel et le e=stcok réel : aucune action.
        autrement, un mouvement de stock est injecté dans le stock pour la différence entre le stock physique et le stock virtuel.
  Back end
    lecture du referenciel par reférence
    lecture du referentiel par barcode
    si inexistance : création dans référentiel & dans stock
    si existant dans référentiel
      controle dans stock : quantité
      si inexistant : création

*/


import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { environment } from '../../../../../../environments/environment';

import { GlobalEventsManagerService } from '../../../../../services/global-events-manager.service';
import { TranslateService } from '@ngx-translate/core';
import { InternationalsFormats, LabelValue, MessageDisplay, ParamLabelsI18n, ParamOtherData, ParamPartsSuppliesModel,
          ParamRatesModel,
          ProfileTax, StockProduct, ToolApiResponse, ToolArgs,
          ToolKeyValue, WksBusinessModel, WksEntity, WksEntityImg, WksEntityParams } from 'src/app/models';
import { WorksService } from 'src/app/services/works.service';
import { SharingDataService } from 'src/app/services/sharing-data.service';

import { ModalCommonComponent } from 'src/app/components/common/modal-common/modal-common.component';
import { CommonMethods } from 'src/app/components/common/tools/commonMethods';
import { DateAdapter } from '@angular/material/core';
import { AuthService } from 'src/app/services/auth.service';
import { BarCode, BrandWksModel, CodeBarScan, MeasurementList } from 'src/app/models/works/wks-common.model';

@Component({
  selector: 'app-movements-card',
  templateUrl: './movements-card.component.html',
  styleUrls: ['./movements-card.component.less']
})
export class MovementsCardComponent implements OnInit, AfterViewInit  {

  @Input()
  wksEntityParams: WksEntityParams;
  @Input()
  wksEntity: WksEntity;
  @Input()
  countryFmt: any;
  @Input()
  applicationStock: string;

  private readonly onDestroy = new Subject<void>();

  doSearchByRef: boolean;
  doSearchByBarCode: boolean;
  okToSearch: boolean;
  displayCreateForm: boolean;
  okToCreate: boolean;
  okToDisplayMenu: boolean;
  btnSearchByRef: boolean;
  btnSearchByBarCode: boolean;
  btnCreateForm: boolean;
  btnQuit: boolean;
  updateBarcodeStock: boolean;

  MIN_CAR = 4;

  messageDialogRef: MatDialogRef<ModalCommonComponent>;
  listProducts: {
    paramPartsSupplies: ParamPartsSuppliesModel;
    stockId?: string;
    stockVirtual?: number;
    stockPhysical?: number;
    stockMovement?: number;
    isCollapsed: boolean;
    isOkToValid: boolean;
  }[];
  displayListProducts: boolean;
  unitsQuantity: LabelValue[];

  profileTax: ProfileTax;
  numberFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
    justifCurrency: string;
    justifText: string;
    justifNumbers: string;
  };

  internationalsFormats: InternationalsFormats;
  dateFormat: string;
  dateFormatMoment: string;
  dateTimeFormat: string;
  localelang: string;
  localeDateFmt: string;
  entityCurrency: string;

  brandsList: BrandWksModel[];
  wareHousesList: {
    warehouseId: string;
    warehouseRef: string;
  }[];
  movementsList: LabelValue[];
  warehouseCur: string;
  movementsCur: string;
  createValues: {
    brandName: string;
    brandBarcode: string;
    ref: string;
    label: string;
    unit: string;
    quantity: number;
    price: number;
  };
  partsRules: {
    partsLabelRegex: string;
    partsLabelMask: string;
    partsRefRegex: string;
    partsRefMask: string;
  };
  suppliersList: WksBusinessModel[];
  supplierCur: WksBusinessModel;
  callScan: string;
  prodCurIdx: number;
  scancodeActivated: boolean;

// element scanner
  scannedCode: string ;
  isScanCodeActive: boolean;
  scannerType: string;
// end scanner auto variables

  constructor(private globalEventsManagerService: GlobalEventsManagerService,
              private worksService: WorksService,
              private translateService: TranslateService,
              private sharingDataService: SharingDataService,
              private adapterDate: DateAdapter<any>,
              private authService: AuthService,
              private matDialog: MatDialog) { }

  ngOnInit(): void {
    this.initAllBooleans();
    this.settingIntFmts();
    this.initParams();
    this.initData();
    // this.loadWareHouses();
    // this.loadBrands();
    // this.loadSuppliers();

    this.loadBrands()
    .then ((response1: any) => {
      this.loadSuppliers()
      .then ((response2: any) => {
          this.loadWareHouses();
        })
      .catch ((error: any) => {
        console.log('loadSuppliers : ' + error);
        return;
      });
    })
    .catch ((error: any) => {
      console.log('loadBrands : ' + error);
      return;
    });

  }
  ngAfterViewInit(): void{
    this.movementsCur = 'output';
    this.movementsChoice(this.movementsCur);
  }

  initData(): void {
    this.wareHousesList = [];
  }
  initAllBooleans(): void {
    this.doSearchByRef = false;
    this.doSearchByBarCode = false;
    this.okToSearch = false;
    this.displayListProducts = false;
    this.displayCreateForm = false;
    this.okToCreate = false;
    this.okToDisplayMenu = false;
    this.scancodeActivated = false;
    this.btnSearchByRef = false;
    this.btnSearchByBarCode = false;
    this.btnCreateForm = false;
    this.btnQuit = false;
    this.updateBarcodeStock = false;
  }
  settingIntFmts(): void {
    const otherData = JSON.parse(this.wksEntity.otherData);
    const internationnalFormat = otherData.internationnalFormat;
    this.internationalsFormats = this.sharingDataService.getIntFormat(internationnalFormat);
    for (const fmtCur of this.internationalsFormats.datetime) {
      if (fmtCur.name === 'dateFormat') {
        this.dateFormat = fmtCur.value;
        this.dateFormatMoment = fmtCur.value;
        this.dateFormatMoment = this.dateFormatMoment.replace('dd', 'DD');
        this.dateFormatMoment = this.dateFormatMoment.replace('yyyy', 'YYYY');
      }
      if (fmtCur.name === 'timeFormat') {
        this.dateTimeFormat = fmtCur.value;
        this.dateTimeFormat = this.dateTimeFormat.replace('dd', 'DD');
        this.dateTimeFormat = this.dateTimeFormat.replace('yyyy', 'YYYY');
      }
    }
    // this.adapterDate.setLocale(this.translate.currentLang);
    const userLang = navigator.language ;
    this.adapterDate.setLocale(userLang ? userLang : otherData.language + '_' + internationnalFormat);
    // this.localelang = userLang;
    this.localelang =  this.translateService.currentLang;
    this.localeDateFmt =  userLang ? userLang : otherData.language + '_' + internationnalFormat;
    const intFormat = otherData.internationnalFormat;
    this.numberFormat = {
      locale: this.sharingDataService.getFormat(intFormat, 'numbers', 'locale'),
      minDecimal: this.sharingDataService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this.sharingDataService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
      currency:  this.sharingDataService.getFormat(intFormat, 'numbers', 'currency'),
      justifCurrency:  this.sharingDataService.getFormat(internationnalFormat, 'justifs', 'currency'),
      justifText:  this.sharingDataService.getFormat(internationnalFormat, 'justifs', 'text'),
      justifNumbers:  this.sharingDataService.getFormat(internationnalFormat, 'justifs', 'numbers')
    };
    const countryDef = this.sharingDataService.getCountry(this.wksEntity.entityCountry);
    const taxProfilesList = countryDef.taxation.profilesTax as ProfileTax[];
    const entityOptions = JSON.parse(this.wksEntity.entityOptions);
    const profileName = entityOptions.taxProfile;
    for (const taxProfileCur of taxProfilesList) {
      if (taxProfileCur.profileName === profileName) {
        this.profileTax = taxProfileCur;
        break;
      }
    }
    const partsRulesTmp = otherData.partsRules;
    if (partsRulesTmp !== undefined) {
          // /^[a-zA-Z0-9-\/]*$
          // [^a-zA-Z0-9-\/]

      this.partsRules =  {
        partsLabelRegex: partsRulesTmp.partsLabelRegex,
        partsLabelMask: partsRulesTmp.partsLabelMask,
        partsRefRegex: partsRulesTmp.partsRefRegex,
        partsRefMask: partsRulesTmp.partsRefMask,
      };
    }
    this.scancodeActivated = this.sharingDataService.getScancodeActivated();
  }
  initParams(): void {
    const countryEntity  = this.sharingDataService.getCountry(this.wksEntity.entityCountry);
    const isMetric = (countryEntity.measurementUnit === 'METRIC');
    const jsonUnits = this.sharingDataService.getUnitsQuantity() as MeasurementList[];
    let measurementLocal = 'METRIC';
    if (!isMetric) {
      measurementLocal = 'NON_METRIC';
    }
    // tires
    this.unitsQuantity  = [];
    for (const measurLocal of jsonUnits) {
      if (measurLocal.measurement === measurementLocal) {
        const arrayUnits = [...measurLocal.list];
        for (const unitName of arrayUnits) {
          this.unitsQuantity.push({
            label: this.translateService.instant('COMMUN.UNITS.' + unitName),
            value: unitName
          });
        }
        break;
      }
    }
    const otherData = JSON.parse(this.wksEntity.otherData);
    const currencyCur = otherData.entityCurrency;
    this.entityCurrency = currencyCur;
    this.movementsList = [];
    this.movementsList.push({
      label: this.translateService.instant('MOVEMENTS.INPUT_MOVEMENTS'),
      value: 'input'
    });
    this.movementsList.push({
      label: this.translateService.instant('MOVEMENTS.OUTPUT_MOVEMENTS'),
      value: 'output'
    });
    if (this.applicationStock === 'inventory') {
      this.movementsCur = this.applicationStock;
    }

    const entityOptions = JSON.parse(this.wksEntity.entityOptions);
    this.isScanCodeActive = false;
    if (entityOptions !== undefined && entityOptions.scanCodeActivation) {
      this.isScanCodeActive = entityOptions.scanCodeActivation;
    }
    this.scannerType = '';
    if (entityOptions.scannerType !== undefined) {
        this.scannerType = entityOptions.scannerType;
    }
    if (entityOptions !== undefined && entityOptions.scanCodeActivation) {
      this.isScanCodeActive = entityOptions.scanCodeActivation;
    }
    /*
    if (this.isScanCodeActive && this.scannerType !== '') {
      this.btnSearchByBarCode = true;
    }
    */
  }
  loadBrands(): any {
    this.brandsList = [];

    return new Promise((resolve, reject) => {
      this.worksService.getWksBrandsList(this.authService.getUserLogged().entity)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          this.brandsList = data.body;

          this.brandsList.sort((obj1, obj2) => {
            return obj1.brandName > obj2.brandName ? 1 : -1;
          });
          resolve(this.brandsList);
        }, err => {
          // console.log(err);
          if (err.status === 404) {
            this.brandsList.push({
              stdEntity: this.authService.getUserLogged().entity,
              brandRow: 'brand',
              brandName: '',
              brandParam: undefined
            });
          }
          reject(err.status);
        }
      );
    });
  }
  // getWksSuppliersList(entity: string): Observable<HttpResponse<WksBusinessModel[]>>
  loadSuppliers(): any {
    this.suppliersList = [];

    return new Promise((resolve, reject) => {
      this.worksService.getWksSuppliersList(this.authService.getUserLogged().entity)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          this.suppliersList = data.body;

          this.suppliersList.sort((obj1, obj2) => {
            return obj1.bsnName > obj2.bsnName ? 1 : -1;
          });
          resolve(this.suppliersList);
        }, err => {
          // console.log(err);
          if (err.status === 404) {
            this.suppliersList.push({
              stdEntity: this.authService.getUserLogged().entity,
              bsnName: 'brand'
            });
          }
          reject(err.status);
        }
      );
    });
  }
  loadWareHouses(): void {
    const apiService = 'warehousesList';
    const apiName = 'stockManagement';
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    this.worksService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {

        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {

        } else  {
          this.affectResponseWharehouses(toolApiResponse);
          this.okToDisplayMenu = true;
        }
      },
      err => {
        console.log('loadWareHouses : ' + JSON.stringify(err));
      }
    );
  }
  affectResponseWharehouses(toolApiResponse: ToolApiResponse): void {

    for (const wareHouseItem of toolApiResponse.toolDatas[0].listValues) {
      const itemWareHouse = {
        warehouseId: wareHouseItem.nws_wharehouse_id,
        warehouseRef: wareHouseItem.nws_wharehouse_ref
      };
      this.wareHousesList.push(itemWareHouse);
    }
    this.warehouseCur = this.wareHousesList[0].warehouseId;
  }
  // warehousesList
  numberAndDotOnly(event: any): boolean {
    // console.log('numberAndDotOnly input ' + event);
    // console.log('numberAndDotOnly return ' + CommonMethods.numberAndDotOnly(event));
    return CommonMethods.numberAndDotOnly(event);
  }

  scannedResponse(scannedCode: string): void {
    this.scannedCode = scannedCode;
  }
  warehouseChoice(value: string): void {
    this.warehouseCur = value;
  }
  movementsChoice(value: string): void {
    this.movementsCur = value;
    this.btnSearchByRef = true;
    if (this.isScanCodeActive && this.scannerType !== '') {
      this.btnSearchByBarCode = true;
    }
    if ( this.movementsCur === 'input') {
      this.btnCreateForm = true;
    } else {
      this.btnCreateForm = false;
    }
  }

  displayScanBarCode(idxProduct: number): void {

    if (!environment.production) {
      this.listProducts[idxProduct].paramPartsSupplies.brandBarcode = environment.barcodeTest;
      this.updateRefentialProduct(idxProduct);
      return;
    }
    this.callScan = 'LINK';
    this.prodCurIdx = idxProduct;
    this.doSearchByBarCode = true;
  }
  searchByRef(): void {
    this.btnSearchByRef = false;
    this.btnSearchByBarCode = false;
    this.btnCreateForm = false;
    this.doSearchByRef = true;
    this.doSearchByBarCode = false;
    this.displayCreateForm = false;
    this.listProducts = [];
  }
  searchByRefForScan(): void {

    this.doSearchByRef = true;
    this.btnSearchByRef = false;
    if (this.isScanCodeActive && this.scannerType !== '') {
      this.btnSearchByBarCode = true;
    }
    this.btnCreateForm = false;
    this.doSearchByBarCode = true;
    this.displayCreateForm = false;
    this.listProducts = [];

  }
  searchByBarCode(): void {

    this.doSearchByBarCode = true;
    this.btnSearchByBarCode = false;
    this.btnSearchByRef = false;
    this.btnCreateForm = false;
    this.doSearchByRef = false;
    this.displayCreateForm = false;
    this.listProducts = [];
  }
  addProduct(): void {
    this.doSearchByBarCode = false;
    this.btnSearchByBarCode = false;
    this.btnSearchByRef = false;
    this.btnCreateForm = false;
    this.doSearchByRef = false;
    this.displayCreateForm = true;
    this.displayListProducts = false;
    this.createValues = {
      brandName: undefined,
      brandBarcode: undefined,
      ref: undefined,
      label: undefined,
      unit: undefined,
      quantity: undefined,
      price: undefined
    };
  }
  createFormBrand(value: string): void {
    this.createValues.brandName = value;
    this.ctrlInputCreate();
  }
  readByScanCode(scanReturn: CodeBarScan): void {
    this.doSearchByBarCode = false;
    if (scanReturn.callMethod === 'SEARCH') {
      this.launchSearchReferential(scanReturn.code, true);
    }
    if (scanReturn.callMethod === 'LINK') {
      this.listProducts[scanReturn.productIdx].paramPartsSupplies.brandBarcode = scanReturn.code;
      this.updateRefentialProduct(scanReturn.productIdx);
    }
  }
  onInputChangeRef(fieldName: string): void {
    const value = CommonMethods.getTextFieldValue(fieldName);
    const pattern = new RegExp(this.partsRules.partsRefRegex, 'g');
    const newValue = value.replace(pattern, '');
    this.createValues.ref = newValue;
    CommonMethods.setTextFieldValue(fieldName, newValue);
  }
  onInputChangeLabel(fieldName: string): void {
    const value = CommonMethods.getTextFieldValue(fieldName);
    const pattern = new RegExp(this.partsRules.partsLabelRegex, 'g');
    const newValue = value.replace(pattern, '');
    this.createValues.label = newValue;
    CommonMethods.setTextFieldValue(fieldName, newValue);
  }

  createFormRef(value: string): void {
    if (value.length < 5) {
      this.createValues.ref = undefined;
    } else {
      this.createValues.ref = value;
    }
    this.ctrlInputCreate();
  }
  createFormLabel(value: string): void {
    this.createValues.label = value;
    this.ctrlInputCreate();
  }
  createFormUnit(value: string): void {
    this.createValues.unit = value;
    this.ctrlInputCreate();
  }
  createFormQty(value: string): void {
    this.createValues.quantity = parseFloat(value);
    this.ctrlInputCreate();
  }
  ctrlInputCreate(): void {
    this.okToCreate = false;
    if (this.createValues.brandName !== undefined &&
      this.createValues.ref !== undefined &&
      this.createValues.label !== undefined &&
      this.createValues.quantity > 0
    ) {
      this.okToCreate = true;
    }
  }
  logout(): void  {

    this.globalEventsManagerService.synchroEvents.next('returnHome__Inventory');
    return;
  }
  ctrlInputRef(inputValue: string): void {
    // console.log(inputValue);
    this.okToSearch = false;
    if (inputValue.trim().length >= this.MIN_CAR) {
      this.okToSearch = true;
    }
  }
  setStockPhysical(value: string, productIdx: number): void {
    const iValue = parseFloat(value);
    this.listProducts[productIdx].isOkToValid = false;
    /*
    if (iValue !== this.listProducts[productIdx].stockPhysical) {
      this.listProducts[productIdx].isOkToValid = true;
    }
    */
    if (iValue !== this.listProducts[productIdx].stockVirtual) {
      this.listProducts[productIdx].stockPhysical = iValue;
      this.listProducts[productIdx].isOkToValid = true;
    }
  }
  setStockMovement(value: string, productIdx: number): void {
    const iValue = parseFloat(value);
    this.listProducts[productIdx].isOkToValid = false;
    /*
    if (iValue !== this.listProducts[productIdx].stockPhysical) {
      this.listProducts[productIdx].isOkToValid = true;
    }
    */
    if (iValue <= this.listProducts[productIdx].stockVirtual) {
      this.listProducts[productIdx].stockMovement = iValue;
      this.listProducts[productIdx].isOkToValid = true;
    }
  }
launchSearchBarcode(inputValue: string): void {
    this.displayListProducts = false;
    if (inputValue.trim().length < this.MIN_CAR) {
      return;
    }

    const messageDisplay: MessageDisplay = {
      titleBox: 'searchListPartsTitle',
      messageLabel: undefined,
      messageArgs: undefined,
      messageBox: this.translateService.instant('INVENTORY.SELECTION_SEARCH', {selectInput: inputValue}),
      messageType: 'ERROR',
      messageDatas: undefined,
      typeDialog: 'infoProgressWks',
      actionCur: 'searchListParts',
      progressDeterminate: false,
    };
    this.messageBoxDisplay(messageDisplay);

    this.worksService.getPartsAndSuppliesList(this.wksEntity.stdEntity, inputValue, true )
    .subscribe(
      (data: any) => {
        this.closeMatDialog();
        const paramPartsSuppliesList = data.body as ParamPartsSuppliesModel[];
        this.affectResponseSearchReferential(paramPartsSuppliesList);
        this.displayListProducts = true;
      },
      err => {
        this.closeMatDialog();
        let messageDisplay2: MessageDisplay;
        if (err.status === 404 ) {
           messageDisplay2 = {
            titleBox: 'searchListPartsTitle',
            messageLabel: undefined,
            messageArgs: undefined,
            messageBox: this.translateService.instant('INVENTORY.SELECTION_SEARCH_KO3', {selectInput: inputValue}),
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'confirmActionYesNo',
            actionCur: 'searchListPartsKO404',
            progressDeterminate: false,
          };
        } else {
          messageDisplay2 = {
            titleBox: 'searchListPartsTitle',
            messageLabel: undefined,
            messageArgs: undefined,
            messageBox: this.translateService.instant('INVENTORY.SELECTION_SEARCH_KO2',
                        {statutReturn:  err.status.toString(), selectInput: inputValue}),
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'alertWks',
            actionCur: 'searchListPartsKO',
            progressDeterminate: false,
          };
        }
        this.messageBoxDisplay(messageDisplay2);
      }
    );

  }
  launchSearchReferential(inputValue: string, scanCode?: boolean): void {
    // console.log(inputValue);
    this.displayListProducts = false;
    if (inputValue.trim().length < this.MIN_CAR) {
      return;
    }

    const messageDisplay: MessageDisplay = {
      titleBox: 'searchListPartsTitle',
      messageLabel: undefined,
      messageArgs: undefined,
      messageBox: this.translateService.instant('INVENTORY.SELECTION_SEARCH', {selectInput: inputValue}),
      messageType: 'ERROR',
      messageDatas: undefined,
      typeDialog: 'infoProgressWks',
      actionCur: 'searchListParts',
      progressDeterminate: false,
    };
    this.messageBoxDisplay(messageDisplay);

    this.worksService.getPartsAndSuppliesList(this.wksEntity.stdEntity, inputValue, scanCode )
    .subscribe(
      (data: any) => {
        this.closeMatDialog();
        const paramPartsSuppliesList = data.body as ParamPartsSuppliesModel[];
        this.affectResponseSearchReferential(paramPartsSuppliesList);
        this.displayListProducts = true;
      },
      err => {
        this.closeMatDialog();
        let messageDisplay2: MessageDisplay;
        if (err.status === 404 ) {
          if (!scanCode) {
            messageDisplay2 = {
              titleBox: 'searchListPartsTitle',
              messageLabel: undefined,
              messageArgs: undefined,
              messageBox: this.translateService.instant('INVENTORY.SELECTION_SEARCH_KO1', {selectInput: inputValue}),
              messageType: 'ERROR',
              messageDatas: undefined,
              typeDialog: 'alertWks',
              actionCur: 'searchListPartsKO',
              progressDeterminate: false,
            };
          } else {
            messageDisplay2 = {
              titleBox: 'searchListPartsTitle',
              messageLabel: undefined,
              messageArgs: undefined,
              messageBox: this.translateService.instant('INVENTORY.SELECTION_SEARCH_KO1', {selectInput: inputValue}),
              messageType: 'ERROR',
              messageDatas: undefined,
              typeDialog: 'alertWks',
              actionCur: 'searchListPartsKO',
              progressDeterminate: false,
            };
          }
        } else {
          messageDisplay2 = {
            titleBox: 'searchListPartsTitle',
            messageLabel: undefined,
            messageArgs: undefined,
            messageBox: this.translateService.instant('INVENTORY.SELECTION_SEARCH_KO2',
                        {statutReturn:  err.status.toString(), selectInput: inputValue}),
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'alertWks',
            actionCur: 'searchListPartsKO',
            progressDeterminate: false,
          };
        }
        this.messageBoxDisplay(messageDisplay2);
      }
    );

  }
  affectResponseSearchReferential(paramPartsSuppliesList: ParamPartsSuppliesModel[]): void {
    this.listProducts = [];
    for (const productItem of paramPartsSuppliesList) {
      const langLabels = productItem.langLabels;
      if (langLabels === null) {
        continue;
      }
      for (const langCur of langLabels) {
        if (langCur === null) {
          continue;
        }
        if (langCur.labelLang === this.authService.getUserLogged().userlang) {
          productItem.paramLabel = langCur.labelText;
          break;
        }
      }
      if (productItem.paramLabel === undefined) {
        productItem.paramLabel = productItem.langLabels[0].labelText;
      }
      if (productItem.brandBarcode === undefined || productItem.brandBarcode === null) {
        productItem.brandBarcode = '';
      }
      const itemPart = {
        paramPartsSupplies: productItem,
        isCollapsed: true,
        isOkToValid: false,
      };
      this.listProducts.push(itemPart);
    }
  }

  readStockByRef(productIdx: number): void {
    if (this.listProducts[productIdx].isCollapsed) {
      return;
    }
    const apiService = 'stockByRef';
    const apiName = 'stockManagement';
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    const toolKeyValue: ToolKeyValue = {
      key: 'brandRef',
      value: this.listProducts[productIdx].paramPartsSupplies.brandRef,
      listValues: undefined,
      arrayValues: undefined
    };
    const jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);
    this.worksService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {

        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {
          const itemResponse = toolApiResponse.toolDatas[0];
          if (itemResponse.value === '404') {
            let paramRate = 0.0;
            const paramRates = this.listProducts[productIdx].paramPartsSupplies.paramRates;
            if (paramRates !== null && paramRates !== undefined && paramRates.length > 0 ) {
              for (const paramRateItem of paramRates ) {
                if (paramRateItem.paramScaleName === 'PUBLIC') {
                  paramRate = paramRateItem.paramRate;
                  if (paramRate === null || paramRate === undefined) {
                    paramRate = 0.0;
                  }
                  break;
                }
              }
            }

            this.createValues = {
                brandName: this.listProducts[productIdx].paramPartsSupplies.brandName,
                brandBarcode: this.listProducts[productIdx].paramPartsSupplies.brandBarcode,
                ref: this.listProducts[productIdx].paramPartsSupplies.brandRef,
                unit: this.listProducts[productIdx].paramPartsSupplies.paramUnit ?
                        this.listProducts[productIdx].paramPartsSupplies.paramUnit : 'unit',
                label: this.listProducts[productIdx].paramPartsSupplies.paramLabel,
                quantity: 0,
                price: paramRate
            };
            this.createStockProduct(false, productIdx);
          }
        } else  {
          this.affectResponseStockByRef(toolApiResponse, productIdx);

        }
      },
      err => {

      }
    );
  }
  readStock(productIdx: number): void {
    if (this.listProducts[productIdx].isCollapsed) {
      return;
    }
    const apiService = 'stock';
    const apiName = 'stockManagement';
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    const toolKeyValue: ToolKeyValue = {
      key: 'nws_stock_id',
      value: this.listProducts[productIdx].stockId,
      listValues: undefined,
      arrayValues: undefined
    };
    const jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);
    this.worksService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {

        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {

        } else  {
          this.affectResponseStock(toolApiResponse, productIdx);

        }
      },
      err => {

      }
    );
  }
  affectResponseStock(toolApiResponse: ToolApiResponse, productIdx: number ): void {

    const itemResponse = toolApiResponse.toolDatas[0];

    const iValue = parseFloat(itemResponse.value);
    this.listProducts[productIdx].stockVirtual = iValue;
  }
  affectResponseStockByRef(toolApiResponse: ToolApiResponse, productIdx: number ): void {

    // const itemResponse = toolApiResponse.toolDatas[0];
    let itemValue = '';
    for (const itemCur of toolApiResponse.toolDatas) {
      if (itemCur.key === 'nws_stock_qty') {
        itemValue = itemCur.value;
        const iValue = parseFloat(itemValue);
        this.listProducts[productIdx].stockVirtual = iValue;
      }
      if (itemCur.key === 'nws_stock_id') {
        this.listProducts[productIdx].stockId = itemCur.value;
      }
    }

  }
  updateProduct(action: string, productIdx?: number, stockPhysicalArg?: number, stockIdArg?: any): void {
    const apiName = 'stockManagement';
    let movementStock ;
    let apiService = 'movementAdd';
    let movementStatut = 'nws_add_qty';
    if (action === 'movements' && productIdx !== undefined) {
      movementStock = this.listProducts[productIdx].stockMovement;
      if (this.movementsCur === 'output') {
        apiService = 'movementLess';
        movementStatut = 'nws_less_qty';
      }
    }
    let supplierCur: WksBusinessModel = null;
    for (const supplierItem of this.suppliersList) {
      if (supplierItem.bsnName === this.listProducts[productIdx].paramPartsSupplies.brandName) {
        supplierCur = supplierItem;
        break;
      }
    }

    if (action === 'inventory' && productIdx !== undefined) { // update
      if (Number.isNaN(this.listProducts[productIdx].stockVirtual) || this.listProducts[productIdx].stockVirtual === undefined) {
        this.listProducts[productIdx].stockVirtual = 0;
      }
      movementStock = this.listProducts[productIdx].stockPhysical - this.listProducts[productIdx].stockVirtual;
      if (movementStock < 0) {
        apiService = 'movementLess';
        movementStock = movementStock * -1;
        movementStatut = 'nws_less_qty';
      }
    }
    if (stockPhysicalArg !== undefined) { // creation
      movementStock = stockPhysicalArg;
    }
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    let toolKeyValue: ToolKeyValue = {
      key: 'product_id',
      value: stockIdArg ? stockIdArg : this.listProducts[productIdx].stockId,
      listValues: undefined,
      arrayValues: undefined
    };
    let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    toolKeyValue = {
      key: 'warehouse_id',
      value: this.warehouseCur,
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    toolKeyValue = {
      key: 'movementcode',
      value: this.authService.getUserLogged().username,
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    toolKeyValue = {
      key: 'movementlabel',
      value: this.translateService.instant('INVENTORY.INVENTORY_LABEL'),
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    toolKeyValue = {
      key: movementStatut,
      value: '' + movementStock,
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);
    this.worksService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {

        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {

        } else  {
          if (productIdx !== undefined) {
            this.readStock(productIdx);
            if (this.updateBarcodeStock) {
              this.updateBarcodeStockProduct(productIdx);
              this.updateBarcodeReferential(productIdx);
              this.updateBarcodeStock = false;
            }
          }
          this.doCancelSearchByBarcode();
          this.doCancelSearchByRef();
        }
        if (productIdx !== undefined) { // update
          this.listProducts[productIdx].isOkToValid = false;
        }
      },
      err => {
         console.log('updateProduct ' + JSON.stringify(err));
      }
    );
  }
   updateBarcodeReferential(productIdx: number): void {
    const paramPartsSupplies = this.listProducts[productIdx].paramPartsSupplies;
    paramPartsSupplies.brandBarcode = this.scannedCode;
    paramPartsSupplies.barcode = this.scannedCode;
    this.worksService.savePartsAndSupplies('update', paramPartsSupplies)
    .subscribe(
      (data: any) => {

      },
      err => {
        console.log('update product error' + JSON.stringify(err));
      }
    );
  }
  updateBarcodeStockProduct(productIdx: number): void {
      const apiService = 'update';
      const apiName = 'stockManagement';
      const toolApiName = this.sharingDataService.stockManagementApi.toolName;

      const toolArgs: ToolArgs = {
        toolDatas: []
      };
      let testData = {
        key: 'toolCustomerNwsCode',
        value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
      };
      toolArgs.toolDatas.push(testData);
      testData = {
        key: 'toolCustomerNwsId',
        value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
      };
      toolArgs.toolDatas.push(testData);

      let toolKeyValue: ToolKeyValue;
      toolKeyValue = {
        key: 'nws_stock_id',
        value: this.listProducts[productIdx].stockId,
        listValues: undefined,
        arrayValues: undefined
      };
      let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);

      toolKeyValue = {
        key: 'nws_label',
        value: this.listProducts[productIdx].paramPartsSupplies.paramLabel,
        listValues: undefined,
        arrayValues: undefined
      };
      jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);

      let nwsBarcodeTypeSelected;
      const barcodeRef: BarCode = this.sharingDataService.getBarcodeRef(this.scannedCode);

      if (barcodeRef !== undefined) {
        for (const toolApiNameCur of barcodeRef.APIS) {
          if (toolApiNameCur.apiName === toolApiName) {
            nwsBarcodeTypeSelected  = toolApiNameCur.nwsBarcodeType;
            break;
          }
        }
        if (nwsBarcodeTypeSelected !== undefined) {
          toolKeyValue = {
            key: 'nws_barcodeType',
            value: '' + nwsBarcodeTypeSelected ,
            listValues: undefined,
            arrayValues: undefined
          };
          jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
          toolArgs.toolDatas.push(jsonTmp);
        }
      }

      toolKeyValue = {
        key: 'nws_barcode',
        value: this.scannedCode,
        listValues: undefined,
        arrayValues: undefined
      };
      jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);

      this.worksService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
      .subscribe(
        (data: any) => {

          const toolApiResponse = data.body as ToolApiResponse;
          const jsonResponse = JSON.stringify(toolApiResponse);
          // console.log(jsonResponse);
          if (toolApiResponse.statut === 'KO') {

          } else  {
            const nwsId =  toolApiResponse.toolDatas[0].value;
          }
        },
        (err: any) => {
          const jsonResponse = JSON.stringify(err);
          console.log('Errot ' + jsonResponse);
        }
      );

    }
  doCancelSearchByBarcode(): void {
    this.doSearchByBarCode = false;
    this.btnSearchByBarCode = true;

    if ( this.movementsCur === 'input') {
      this.btnCreateForm = true;
    } else {
      this.btnCreateForm = false;
    }
    this.btnSearchByRef = true;
    this.listProducts = [];
    this.scannedCode = '';
  }
  doCancelSearchByRef(): void {
    this.doSearchByRef = false;
    this.btnSearchByRef = true;
    if ( this.movementsCur === 'input') {
      this.btnCreateForm = true;
    } else {
      this.btnCreateForm = false;
    }
    this.btnSearchByBarCode = true;
    this.listProducts = [];
  }
  doCancelCreateForm(): void {
    if ( this.movementsCur === 'input') {
      this.btnCreateForm = true;
    } else {
      this.btnCreateForm = false;
    }
    this.displayCreateForm = false;
    this.btnSearchByBarCode = true;
    this.btnSearchByRef = true;
  }
  createProduct(): void {
    const paramPartsSuppliesCard = this.fillModel();
    this.worksService.savePartsAndSupplies('create', paramPartsSuppliesCard)
    .subscribe(
      (data: any) => {
        this.createStockProduct(true);
      },
      err => {
        console.log('createProduct error' + JSON.stringify(err));
      }
    );
  }
  updateRefentialProduct(productIdx: number): void {
    const paramPartsSuppliesCard = this.fillRefentialModel(productIdx);
    this.worksService.savePartsAndSupplies('update', paramPartsSuppliesCard)
    .subscribe(
      (data: any) => {
        this.createStockProduct(true);
      },
      err => {
        console.log('createProduct error' + JSON.stringify(err));
      }
    );
  }
  createStockProduct(isNewProduct: boolean, productIdx?: number): void {

    const apiService = 'create';
    const apiName = 'stockManagement';
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    let toolKeyValue: ToolKeyValue = {
      key: 'nws_label',
      value: this.createValues.label,
      listValues: undefined,
      arrayValues: undefined
    };
    let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    toolKeyValue = {
      key: 'brandRef',
      value: this.createValues.ref,
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    toolKeyValue = {
      key: 'brandName',
      value: this.createValues.brandName,
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);
    if (this.createValues.price !== undefined) {
      toolKeyValue = {
        key: 'nws_stock_price',
        value: '' + this.createValues.price.toString(),
        listValues: undefined,
        arrayValues: undefined
      };
      jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);
    }

    this.worksService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {

        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {

        } else  {
          const nwsId =  toolApiResponse.toolDatas[0].value;
          if (isNewProduct) { // inexistant en refrentiel et en stock
            this.displayCreateForm = false;
            this.updateProduct('create', undefined, this.createValues.quantity, nwsId);
            this.launchSearchReferential(this.createValues.ref);
          } else {
            this.listProducts[productIdx].stockId = nwsId;
            this.listProducts[productIdx].stockVirtual = 0;
          }
        }
      },
      err => {

      }
    );

  }
  fillModel(): ParamPartsSuppliesModel {

    const paramOtherData: ParamOtherData = {
      stockRefExists: true,
      accountingBuy: '0.0',
      accountingSale: '0.0'
    };
    const paramLabelsI18n: ParamLabelsI18n[] = [];
    // parampartssupplies
    const paramLabelItem: ParamLabelsI18n = {
      stdEntity: this.wksEntity.stdEntity,
      labelModule: 'parampartssupplies',
      labelObject: undefined,
      labelLang: this.authService.getUserLogged().userlang,
      labelText: this.createValues.label,
    };
    paramLabelsI18n.push(paramLabelItem);
    const paramPartsSupplies: ParamPartsSuppliesModel = {
        id: undefined,
        stdEntity: this.wksEntity.stdEntity,
        paramType: 'part',
        brandName: this.createValues.brandName,
        brandRef: this.createValues.ref,
        brandBarcode: this.createValues.brandBarcode,
        paramUnit: this.createValues.unit !== undefined &&  this.createValues.unit !== null && this.createValues.unit !== '' ?
                  this.createValues.unit : 'unit',
        paramCurrency: undefined,
        otherData: JSON.stringify(paramOtherData),
        langLabels: paramLabelsI18n,
        userLang: this.localelang,
        paramLabel: this.createValues.label
    };
    const paramRatesTmp: ParamRatesModel = {
      stdEntity: this.wksEntity.stdEntity,
      paramScaleName: 'PUBLIC',
      paramRate: 0,
      paramCurrency: this.entityCurrency,
      otherData: ''
    };
    const paramRatesLocal: ParamRatesModel[] = [];
    paramRatesLocal.push(paramRatesTmp);
    paramPartsSupplies.paramRates = paramRatesLocal;
    return paramPartsSupplies;
  }
  fillRefentialModel(productIdx: number): ParamPartsSuppliesModel {

    const localParamPartSupplies =  this.listProducts[productIdx].paramPartsSupplies;

    const paramOtherData: ParamOtherData = {
      stockRefExists: true,
      accountingBuy: '0.0',
      accountingSale: '0.0'
    };
    const paramLabelsI18n: ParamLabelsI18n[] = [];
    // parampartssupplies
    const paramLabelItem: ParamLabelsI18n = {
      stdEntity: this.wksEntity.stdEntity,
      labelModule: 'parampartssupplies',
      labelObject: undefined,
      labelLang: this.authService.getUserLogged().userlang,
      labelText: localParamPartSupplies.paramLabel,
    };
    paramLabelsI18n.push(paramLabelItem);
    const paramPartsSupplies: ParamPartsSuppliesModel = {
        id: localParamPartSupplies.id,
        stdEntity: this.wksEntity.stdEntity,
        paramType: 'part',
        brandName: localParamPartSupplies.brandName,
        brandRef: localParamPartSupplies.brandRef,
        brandBarcode: localParamPartSupplies.brandBarcode,
        paramUnit: localParamPartSupplies.paramUnit,
        paramCurrency: localParamPartSupplies.paramCurrency,
        otherData: JSON.stringify(paramOtherData),
        langLabels: paramLabelsI18n,
        userLang: this.localelang,
        paramLabel: localParamPartSupplies.paramLabel
    };

    paramPartsSupplies.paramRates = localParamPartSupplies.paramRates;
    return paramPartsSupplies;
  }
// ========================================================== errors alerts
 messageBoxDisplay(messageDisplay: MessageDisplay): void {

  const dialogConfig = new MatDialogConfig();
  let messageBox = '';
  if (messageDisplay.messageBox !== undefined) {
    messageBox = messageDisplay.messageBox;
  } else  {
    messageBox = this.translateService.instant('INVENTORY.' + messageDisplay.messageLabel, messageDisplay.messageArgs );
  }

  // const messageDisplayCACHE = JSON.parse(JSON.stringify(messageDisplay));
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.data = {
    id: 1,
    title: this.translateService.instant( 'INVENTORY.' + messageDisplay.titleBox),
    typeDialog: messageDisplay.typeDialog,
    panelClass: 'stdTheme',
    contentMessage: messageBox,
    data1: messageDisplay.messageDatas,
    data2: '',
    actionCur: messageDisplay.actionCur,
    progressDeterminate: messageDisplay.progressDeterminate,
    errorsList: undefined,
    messageType: messageDisplay.messageType
  };
  this.messageDialogRef = this.matDialog.open(ModalCommonComponent, dialogConfig);

  this.messageDialogRef.afterClosed()
  .pipe(takeUntil(this.onDestroy))
  .subscribe(
    (data: any) => {
      // data: "okAction"
      if (messageDisplay.actionCur === 'searchListPartsKO404') {
        if (data === 'okAction') {
          this.endProcessFile();
          this.updateBarcodeStock = true;
          this.searchByRefForScan();
        }

        if (data === 'cancelAction') {
          this.endProcessFile();
          this.doCancelSearchByBarcode();
        }
      }
      if (data === 'okAction') {
        if (messageDisplay.actionCur === 'verifyStockParts') {
          this.endProcessFile();
        }
        if (messageDisplay.actionCur === 'verifyStockPartsDone') {
          this.endProcessFile();
        }
        if (messageDisplay.actionCur === 'verifyStockPartsFailed') {
          this.endProcessFile();
        }

      }
    });
  }
  closeMatDialog(): void {
    this.matDialog.closeAll();

    // console.log(this._dialog.openDialogs.length);
    if (this.matDialog.openDialogs.length > 0) {

      for (const instCur of this.matDialog.openDialogs) {
        this.matDialog.openDialogs.splice(0, 1);
      }
    }
    this.messageDialogRef = null;
  }
  private endProcessFile(): void {
    this.closeMatDialog();
  }
}
